import React, { useCallback, useRef, useState } from "react";
import { Card, CardContent } from "semantic-ui-react";
import Tab from "../../components/Tab";
import { Search } from "react-feather";
import InvoiceSearchComponent from "../../components/finance/InvoiceSearchComponent";
import {
  getInvoiceById,
  invoiceSearch,
} from "../../api/finance/invoiceSearchApi";
import LoadingSpinner from "../../components/LoadingSpinner";
import Grid from "../../components/Grid";
import EvinvComponent from "../../components/finance/EvInv/EVINVComponent";
import SideDrawer from "../../components/input/SideDrawer";
import { formatFromJsonDate } from "../../dateConfig";

function InvoiceSearch() {
  const gridRef = useRef();

  const [tab, setTab] = useState(1);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [invoiceParams, setInvoiceParams] = useState([]);

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleSearch = async (data) => {
    setSearchClicked(true);
    setIsLoading(true);
    const result = await invoiceSearch(data);
    console.log("Invoice Search: ", result);
    setJobs(
      result.map((jobDetails) => ({
        ...jobDetails,
        createdFormatDate: formatFromJsonDate(result.createddate),
      })),
    );
    setSelectedRows([]);
    setIsLoading(false);
  };

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  const cellDoubleClickHandler = async (params) => {
    const invoiceById = await getInvoiceById(params.data.eihid);
    console.log("invoiceById: ", invoiceById);
    setInvoiceParams(invoiceById);
    setJobId(invoiceById.eihJobId);
    setCategoryId(invoiceById.eihType);

    setIsDrawerOpen(true);
  };

  return (
    <>
      <Card style={{ width: "100%" }}>
        <CardContent>
          <div className="ui tabular menu top attached">
            <Tab
              Icon={Search}
              onClick={() => {
                setTab(1);
              }}
              active={tab === 1}
              label="Search"
            />
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none" }}
          >
            <InvoiceSearchComponent searchResHandler={handleSearch} />
            {searchClicked && (
              <>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    <Grid
                      ref={gridRef}
                      wrapText={false}
                      multiRowSelection={false}
                      onSelectionChanged={handleSelectionChanged}
                      isLoading={isLoading}
                      searchable={false}
                      config={[
                        {
                          headerName: "EV/INV Code",
                          field: "eihcode",
                          headerCheckboxSelection: true,
                          checkBoxSelection: true,
                          pinned: "left",
                          minWidth: 150,
                          width: 150,
                          filter: true,
                        },
                        {
                          headerName: "Single Or Bulk",
                          field: "eihsingle_bulk_desc",
                        },
                        { headerName: "Type name", field: "eihtype_name" },
                        { headerName: "EV Or INV", field: "ceihtype" },
                        { headerName: "Job Code", field: "eihjob_no" },
                        { headerName: "Amount", field: "eihwith_tax" },
                        {
                          headerName: "Amount Without Tax",
                          field: "eihwithout_tax",
                        },
                        { headerName: "Status", field: "eihstatus_name" },
                        {
                          headerName: "Integration Status",
                          field: "eihIntStatusValue",
                        },
                        {
                          headerName: "Created Date",
                          field: "createdFormatDate",
                          minWidth: 250,
                        },
                        { headerName: "Created By", field: "createdby" },
                      ]}
                      content={jobs}
                      onRowDoubleClicked={cellDoubleClickHandler}
                    />
                  </>
                )}
                <SideDrawer
                  open={isDrawerOpen}
                  handleDrawerClose={handleDrawerClose}
                  head={
                    <div className="drawer-header">
                      <div style={{ padding: "10px 0 10px 0" }}>
                        <h3>EV/Inv Generator</h3>
                      </div>
                    </div>
                  }
                  body={
                    <EvinvComponent
                      categoryId={categoryId}
                      jobId={jobId}
                      editMode={true} // Pass editMode as true
                      invoiceParams={invoiceParams} // Pass invoiceParams
                    />
                  }
                  style={{ width: "90vw", boxShadow: "none" }}
                />
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </>
  );
}

export default InvoiceSearch;
